export default {
      id: "account_balance-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#account_balance",
      toString: function () {
        return this.url;
      }
    }